import { AliasMacronMapper } from "@at.govt.nz/gtfs-name-mapping-util";
import FeatureFlagService from "./FeatureFlagService";
import { ENABLE_DISPLAY_MACRONS, ENABLE_SEARCH_ALIAS } from "../constants/featureFlags";

let instance;

const init = async () => {
  if (instance) return;

  instance = await AliasMacronMapper.create({
    tablesBaseUrl: `${process.env.REACT_APP_AT_API_URL}/digital/v2/mappings`,
    requestHeaders: { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_AT_API_KEY },
  });
};

const getMacronisedText = (text) => {
  if (!FeatureFlagService.featureEnabled(ENABLE_DISPLAY_MACRONS, false)) return text;
  return instance ? instance.macroniseText(text) : text;
};

const getAlias = (text) => {
  if (!FeatureFlagService.featureEnabled(ENABLE_SEARCH_ALIAS, false)) return null;
  return instance ? instance.getAlias(text) : null;
};

export default { getMacronisedText, getAlias, init };
